export default "__VITE_ASSET__Drr2fUbe__"